const showTotal = (total: number, range: [number, number]) =>
  `${range[0]}-${range[1]} of ${total} items`;

export default showTotal;
